export function DropDownField(props: {
  label: string;
  value: string;
  setValue: (value: string) => void;
  options: string[];
}) {
  const { label, value, setValue, options } = props;
  return (
    <div className="flex flex-grow flex-col gap-1">
      <label>{label}</label>
      <select
        className={`flex-grow rounded border p-1 text-center`}
        value={value}
        onChange={(e) => setValue(e.target.value)}
      >
        <option value="" disabled selected>
          Select an option
        </option>
        {options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  );
}
